import {
  sonder,
  verona,
  logoCrucijuegos,
  logoElGrafico,
  logoTorneos,
  logoSanCristobal,
  logoFlydevs,
  logoMarriottWhite,
  logoEnaproWhite,
  logoPrevincaWhite,
} from "@/assets";

export interface ClientBrand {
  name: string;
  logo?: string;
  /** Sufijo de marca para el modificador de tamaño optico (brand-marquee__logo--<brand>). */
  brand?: string;
}

/**
 * Clientes de WAIA, en el orden provisto por la empresa. Una sola lista para
 * el marquee del hero y el muro de logos de /empresas: si se suma o se saca
 * un cliente, cambia en los dos lados.
 *
 * Todos los logos con imagen son variantes para fondo oscuro (ver el
 * comentario de BrandMarquee sobre las variantes negativas).
 */
export const CLIENT_BRANDS: ClientBrand[] = [
  { name: "Marriott Bonvoy", logo: logoMarriottWhite, brand: "marriott" },
  { name: "ENAPRO", logo: logoEnaproWhite, brand: "enapro" },
  { name: "Neumáticos Verona", logo: verona, brand: "verona" },
  { name: "FlyDevs", logo: logoFlydevs, brand: "flydevs" },
  { name: "Grupo San Cristóbal", logo: logoSanCristobal, brand: "sancristobal" },
  { name: "Crucijuegos", logo: logoCrucijuegos, brand: "crucijuegos" },
  { name: "Grupo Previnca", logo: logoPrevincaWhite, brand: "previnca" },
  { name: "FunesCoop" },
  { name: "Banco Municipal de Rosario" },
  { name: "Cooperativa VGG" },
  { name: "Sonder", logo: sonder, brand: "sonder" },
  { name: "Torneos", logo: logoTorneos, brand: "torneos" },
  { name: "El Gráfico", logo: logoElGrafico, brand: "elgrafico" },
];
